// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:769px){.button\\@md--format-18{height:18px;padding:0}.button\\@md--format-32,.button\\@md--format-34{height:32px;padding:0 16px}.button\\@md--format-42{height:42px;padding:0 20px}}", ""]);
// Exports
module.exports = exports;
